import Navbar from './components/Navbar';
import Hero from './components/Hero';
import AgentCards from './components/AgentCards';
import Architecture from './components/Architecture';
import Stats from './components/Stats';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <AgentCards />
      <Architecture />
      <Stats />
      <Footer />
    </div>
  );
}

export default App;
